import { gql } from '@apollo/client'

export const BLOCK_IP = gql`
  mutation BlockIp($input: BlockIpInput!) {
    blockIp(input: $input) {
      id
      ipAddress
    }
  }
`

export const UNBLOCK_IP = gql`
  mutation UnblockIp($ipAddress: String!) {
    unblockIp(ipAddress: $ipAddress) {
      id
      ipAddress
    }
  }
`

export const BLOCK_USER = gql`
  mutation BlockUser($userId: Int!) {
    blockUser(userId: $userId)
  }
`

export const RESOLVE_SUSPICIOUS_ACTIVITY = gql`
  mutation ResolveSuspiciousActivity($id: Int!) {
    resolveSuspiciousActivity(id: $id) {
      id
      resolved
    }
  }
`
